const assignNew = (data, allFiles) => {
    if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const each = Object.assign({
                id: data[i].request_document_id,
                url: data[i].request_document_url,
            });
            allFiles.push(each);
        }
    }
}

export default assignNew;